import LumenCloudService from './lumenCloudService';

export default LumenCloudService;
